// extracted by mini-css-extract-plugin
export var hideEditor = "_ne-2";
export var infoIcon = "_ne-3";
export var label = "_ne-1";
export var labelContainer = "_ne-0";
export var readonlyText = "_ne-4";